<ng-container *ngIf="data.length>0">
<div class="ticket" *ngFor="let copia of copias; let primera = first; let ultima = last" [class.copia-extra]="!primera" [class.ultima]="ultima">
    <div style="text-align:center; width:300px;">
        <img src="../../assets/logo2.png" style="width:150px; " />
    </div>

    <table style="max-width: 400px; width: 300px;">
        <tbody>
            <tr>
                <th style="font-size: x-large;">
                    <p style="text-align:center;font-size: x-large;">Votaciones
                        2026<br />Ticket<br />
                        {{data[0]['idTicket']}}
                        <br />
                        <FONT face="arial" SIZE="1"> <span style=" font-size: large;">Fecha:
                                {{data[0]['fechaVotacion'] | date: "dd/MM/yyyy" : "UTC"}} Hora:
                                {{data[0]['horaVotacion']}}</span></FONT>
                    </p>
                    <p style="text-align:center;font-size:30px;">  Votos </p>
                    <p style="text-align:center;font-size:90px;">   {{data.length}} </p>
                    
                    <p style="text-align:center;font-size: x-large;">Atendido en: {{data[0]['usuario']}} </p>
                    <p style="text-align:center; background-color: #CCCCCC;font-size:large;">Nombre Completo </p>
                </th>
            </tr>
            <tr *ngFor="let datos of data">

                <td style=" padding-left:5px; text-align:left;">
                    <FONT face="arial" SIZE="0">
                        <span style=" font-size: large;">
                            {{datos['nombreCompleto']}}
                        </span>
                    </FONT>
                </td>
            </tr>
            <hr />
            <br />
            <br />
            <br />
            
            <hr>
            <div style="text-align:center; width:300px; font-size: large;">
                <b>Firma de Encargado Votación</b>
            </div>
            <hr>
            <div style="text-align:center; width:300px; font-size: large;">
                <qrcode [qrdata]="qrData" [width]="150" [margin]="5" [elementType]="img"
                        [errorCorrectionLevel]="'M'">
                    </qrcode> 
                    </div>
        </tbody>
    </table>
</div>
</ng-container>
<div class="acciones oculto-impresion">
    <button type="button" class="accion accion-secundaria" (click)="fnRegresar()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
        </svg>
        Regresar
    </button>
    <button type="button" class="accion accion-principal" (click)="fnImprimir()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5z" />
            <path fill-rule="evenodd"
                d="M11 9H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
            <path fill-rule="evenodd"
                d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
        </svg>
        Imprimir
    </button>
</div>